import React from "react";
import { convertTime } from "../../../../../../helpers/helpers";
import StatusIcons from "../../../../../../Components/StatusIcons/StatusIcons";
import { useOrderVisibility } from "../../../../../../helpers/useOrderVisibility";
import { useTranslation } from "react-i18next";

export default function OrderDetails({
  data,
  AdditionalCostTotal,
  type = "show",
  Packinglist,
}) {
  const { t } = useTranslation("warehouse");
  // The fulfilment charge needs "View price".
  const { showPrices } = useOrderVisibility();
  return (
    <>
      <div className="invmodal__ship_details_top_wrap">
        {/* order details */}
        <div className="invoice__modal_order_shipment_summary order_detail_modal_wrap">
          <div className="invmodal__shipment_summarycntnt">
            <div className="invmodal__shipment_summaryfrom">
              <div className="invmodal__shipment_sumitemhding">{t("orderDetails.shipper")}</div>
              <div className="invmodal__shipment_sumitem">
                <div className="invmodal__shipment_sumitemleft" hidden>
                  {t("orderDetails.name")}
                </div>
                <div className="invmodal__shipment_sumitemright">
                  {data?.order_pickup_details?.[0]?.["attention"] ?? ""}{" "}
                  {data?.order_pickup_details?.[0]?.["company"] && (
                    <> ( {data?.order_pickup_details?.[0]?.["company"]} )</>
                  )}
                  {/* ( {data?.order_pickup_details?.[0]?.["company"] ?? " "} ) */}
                </div>
              </div>
              <div className="invmodal__shipment_sumitem">
                <div className="invmodal__shipment_sumitemright">
                  {data?.order_pickup_details?.[0]?.["email"] ?? ""}{" "}
                  {data?.order_pickup_details?.[0]?.["email"] &&
                    data?.order_pickup_details?.[0]?.["phone"] && (
                      <>
                        {" "}
                        <span> - </span>{" "}
                      </>
                    )}
                  {data?.order_pickup_details?.[0]?.["phone"] ?? ""}
                </div>
              </div>
              <div className="invmodal__shipment_sumitem">
                <div className="invmodal__shipment_sumitemleft" hidden>
                  {t("orderDetails.address")}
                </div>
                <div className="invmodal__shipment_sumitemright">
                  {data?.order_pickup_details?.[0]?.["full_address"] ?? ""}{" "}
                  {data?.order_pickup_details?.[0]?.["zip_postal"] ?? ""}
                </div>
              </div>
            </div>
            <div className="invmodal__shipment_summaryto">
              <div className="invmodal__shipment_sumitemhding">{t("orderDetails.recipient")}</div>
              <div className="invmodal__shipment_sumitem">
                <div className="invmodal__shipment_sumitemleft" hidden>
                  {t("orderDetails.name")}
                </div>
                <div className="invmodal__shipment_sumitemright">
                  {data?.order_shipping_address_details?.first_name ?? ""}{" "}
                  {data?.order_billing_address_details?.company && (
                    <> ( {data.order_billing_address_details.company} )</>
                  )}
                </div>
              </div>

              <div className="invmodal__shipment_sumitem">
                <div className="invmodal__shipment_sumitemright">
                  {data?.order_billing_address_details?.email ?? ""}{" "}
                  {data?.order_billing_address_details?.email &&
                    data?.order_billing_address_details?.phone && (
                      <>
                        <span> - </span>
                      </>
                    )}
                  {data?.order_billing_address_details?.phone ?? ""}
                </div>
              </div>
              <div className="invmodal__shipment_sumitem">
                <div className="invmodal__shipment_sumitemleft" hidden>
                  {t("orderDetails.address")}
                </div>
                <div className="invmodal__shipment_sumitemright">
                  <div className="invmodal__shipment_sumitemright">
                    {(() => {
                      const {
                        address_1 = "",
                        postcode = "",
                        city = "",
                        state_name = "",
                        country_name = "",
                      } = data?.order_shipping_address_details || {};

                      const addressParts = [];
                      const lowerAddress = address_1.toLowerCase();

                      // Add address_1 first
                      if (address_1) addressParts.push(address_1);

                      // Add only if not already included in address_1
                      if (
                        postcode &&
                        !lowerAddress.includes(postcode.toLowerCase())
                      ) {
                        addressParts.push(postcode);
                      }
                      if (city && !lowerAddress.includes(city.toLowerCase())) {
                        addressParts.push(city);
                      }
                      if (
                        state_name &&
                        !lowerAddress.includes(state_name.toLowerCase())
                      ) {
                        addressParts.push(state_name);
                      }
                      if (
                        country_name &&
                        !lowerAddress.includes(country_name.toLowerCase())
                      ) {
                        addressParts.push(country_name);
                      }

                      return addressParts.join(", ");
                    })()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* order details */}
        {/* header */}
        <div className="invoice__modal_order_details_header">
          <div className="invoice__modal_header_date_details content__orderid_date">
            <div className="invmodal__hright_infoitem">
              <div className="invmodal__hright_infoitem_item_wrapper">
                <div className="invmodal__hright_infoitemleft">{t("orderDetails.orderDate")}</div>
                <div className="invmodal__hright_infoitemright">
                  {convertTime(data?.created_at)}
                </div>
              </div>
            </div>
            <div className="invmodal__hright_infoitem">
              <div className="invmodal__hright_infoitem_item_wrapper">
                <div className="invmodal__hright_infoitemleft">{t("orderDetails.orderId")}</div>
                <div className="invmodal__hright_infoitemright">
                  {data?.order_id ?? ""}
                </div>
              </div>
            </div>
            <div className="invmodal__hright_infoitem">
              <div className="invmodal__hright_infoitem_item_wrapper">
                <div className="invmodal__hright_infoitemleft">{t("orderDetails.createdBy")}</div>
                <div className="invmodal__hright_infoitemright">
                  {data?.created_by?.username?.trim() ||
                    data?.user?.username?.trim() ||
                    "-"}
                </div>
              </div>
            </div>
            <div className="invmodal__hright_infoitem">
              <div className="invmodal__hright_infoitem_item_wrapper">
                <div className="invmodal__hright_infoitemleft">{t("orderDetails.orderType")}</div>
                <div className="invmodal__hright_infoitemright">
                  {data?.type ?? ""}
                </div>
              </div>
            </div>
            <div className="invmodal__hright_infoitem">
              <div className="invmodal__hright_infoitem_item_wrapper  invmodal__hright_infoitem_item_wrapper_with_bg">
                <div className="invmodal__hright_infoitemleft">
                  {t("orderDetails.orderStatus")}
                </div>
                <div className="invmodal__hright_infoitemright">
                  {data?.status ?? "-"}
                </div>
              </div>
            </div>

            {data?.amount_pending ? (
              <>
                <div className="invmodal__hright_infoitem">
                  <div className="invmodal__hright_infoitem_item_wrapper invmodal__hright_infoitem_item_wrapper_with_bg">
                    <div className="invmodal__hright_infoitemleft">
                      {t("orderDetails.amountPending")}
                    </div>
                    <div className="invmodal__hright_infoitemright">
                      {data?.amount_pending ?? "0"} $
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            <div className="invmodal__hright_infoitem">
              <div className="invmodal__hright_infoitem_item_wrapper invmodal__hright_infoitem_item_wrapper_with_bg">
                <div className="invmodal__hright_infoitemleft">
                  {t("orderDetails.fulfilmentStatus")}
                </div>
                <div className="invmodal__hright_infoitemright">
                  <StatusIcons
                    status={data?.fullfilment_status?.name}
                    showTitle={type !== "print"}
                    isPrint={type === "print"}
                    noDot={type === "print"}
                    noBg
                  />
                </div>
              </div>
            </div>
          </div>
          {!Packinglist && (
            <div className="invoice__modal_header_content">
              <div className="invmodal__hleft_infoitems">
                <div className="invmodal__hleft_infoitem">
                  {data?.user?.business_name ?? ""}
                </div>
                <div className="invmodal__hleft_infoitem">
                  {data?.user?.address ?? ""}
                </div>
                <div className="invmodal__hleft_infoitem">
                  {data?.user?.zip ?? ""}
                </div>
                <div className="invmodal__hleft_infoitem">
                  {data?.user?.email ?? ""}
                </div>
                <div className="invmodal__hleft_infoitem">
                  {data?.user?.phone ?? ""}
                </div>
              </div>
              {showPrices && (
                <div className="invmodal__hleft_amntitems">
                  <div className="invmodal__hleft_amntitem">
                    <div className="invmodal__hleft_amntitemleft bold_700">
                      {t("orderDetails.totalFulfilmentChargeOfOrder")}
                    </div>
                    <div className="invmodal__hleft_amntitemright">
                      {parseFloat(
                        parseFloat(data?.fulfillment_cost) +
                          parseFloat(AdditionalCostTotal),
                      ).toFixed(2) + "$" ?? ""}
                    </div>
                    {/* <div className="invmodal__hleft_amntitemright">
                            {data?.Total}$
                            <sup>
                              {data?.shipment_charges?.length > 1
                                ? `*${data?.shipment_charges?.length}`
                                : ""}
                            </sup>
                            <span
                              className={
                                type == "Show"
                                  ? "invmodal__hleft_airprevcharge"
                                  : "invmodal__hleft_airprevcharge invmodal__paymentterms_linethrough2"
                              }
                            >
                              {data?.shipment_charges?.length > 1
                                ? data?.shipment_charges[
                                    data?.shipment_charges?.length - 2
                                  ]?.total
                                : ""}
                            </span>
                          </div> */}
                  </div>
                  {/* <div className="invmodal__hleft_amntitem">
                          <div className="invmodal__hleft_amntitemleft">
                            Your payment is due by (Y-M-D)
                          </div>
                          <div className="invmodal__hleft_amntitemright">-</div>
                        </div> */}
                </div>
              )}
            </div>
          )}
        </div>
        {/* header */}
      </div>
    </>
  );
}
